import AdvanceTable from 'componentes/common/advance-table/AdvanceTable.js';
import AdvanceTableFooter from 'componentes/common/advance-table/AdvanceTableFooter.js';
import AdvanceTableSearchBox from 'componentes/common/advance-table/AdvanceTableSearchBox.js';
import FalconComponentCard from 'componentes/common/FalconComponentCard.js';
import AdvanceTableProvider from 'context/AdvanceTableProvider.js';
import useAdvanceTable from 'hooks/useAdvanceTable.js';
import React, { useMemo, useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const GenericTable = ({ data, columns, addAction, title }) => {
  const skipPageResetRef = useRef();
  const dataMemo = useMemo(() => data);
  const columnsMemo = useMemo(() => columns, []);

  const table = useAdvanceTable({
    data: dataMemo,
    columns: columnsMemo,
    sortable: true,
    pagination: true,
    perPage: 10,
    autoResetPageIndex: !skipPageResetRef.current,
    autoResetExpanded: !skipPageResetRef.current
  });
  return (
    <>
      {' '}
      <FalconComponentCard>
        <FalconComponentCard.Header
          title={title}
          light={false}
          AddAction={addAction}
        />

        <AdvanceTableProvider {...table}>
          <Row className="flex-end-center mb-3">
            <Col xs="auto" sm={6} lg={4}>
              <AdvanceTableSearchBox />
            </Col>
          </Row>
          <AdvanceTable
            headerClassName="bg-200 text-900 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: 'sm',
              striped: true,
              className: 'fs--1 mb-0 overflow-hidden'
            }}
          />
          <div className="mt-3" style={{ minHeight: '50px', padding: '5px' }}>
            <AdvanceTableFooter
              viewAllBtn={false}
              rowInfo
              navButtons
              rowsPerPageSelection
            />
          </div>
        </AdvanceTableProvider>
      </FalconComponentCard>
    </>
  );
};
GenericTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  addAction: PropTypes.func
};
export default GenericTable;
